export const themeColors = {
    themeColor: '#f9f9f9',
    textColor: '#005eb8',
    borderColor: 'rgba(0, 0, 0, 0.23)',
  };